<template>
  <div class="main">
    <FormWrapper :action="formAction" :method="formMethod">
      <div class="title-bar">
        <h1 class="mb-0">{{ video.id ? "Edit" : "Add New" }} Video</h1>
        <a class="btn-back" :href="route('admin.videos.index')">
          <span class="icon icon-arrow-left"></span>
          <span class="text">Back to List</span>
        </a>
      </div>
      <div class="row no-gutters py-4">
        <div class="col-12 col-lg-8 col-xl-9">
          <div class="row no-gutters pl-4">
            <div class="col-12">
              <transition name="fade">
                <Alert v-if="hasAlert" :alert="alert" />
              </transition>
            </div>
            <div class="col-12 mb-3 col-lg-8 pr-lg-4">
              <Field
                type="text"
                name="title"
                label="Title"
                :value="video.title"
                validate="required"
              />
            </div>
            <div class="col-12 mb-3 col-lg-4">
              <Field
                type="text"
                name="brightcove_id"
                label="Brightcove ID"
                :value="video.brightcove_id"
                validate="required"
                validate-as="brightcove ID"
              />
            </div>
            <div class="col-12 mb-3 col-lg-8 pr-lg-4">
              <Field type="text" name="keywords" label="Keywords" :value="video.keywords" />
            </div>
            <div class="col-12 mb-3 col-lg-4">
              <Field type="text" name="length" label="Length" :value="video['length']" />
            </div>
            <div class="col-12 mb-3 col-lg-4 pr-lg-4">
              <Field
                type="datepicker"
                name="publish_on"
                label="Publish Date"
                v-model="publishOn"
                validate-as="publish date"
              />
            </div>
            <div class="col-12 mb-3 col-lg-4 pr-lg-4">
              <Field
                type="datepicker"
                name="expires_on"
                label="Expiration Date"
                v-model="expiresOn"
              />
            </div>
            <div class="col-12 mb-3 col-lg-4">
              <Field type="text" name="status" label="Status" :value="status" :disabled="true" />
            </div>
            <div class="col-12">
              <Field
                type="checkbox"
                name="distributors_only"
                id="distributors_only"
                label="Restrict access to this video to only distributors"
                :value="video.distributors_only"
                :checkbox-value="1"
              />
            </div>
            <div class="col-12">
              <Field
                  type="checkbox"
                  name="factory_only"
                  id="cb_factory_only"
                  label="Restrict access to this video to only factory users"
                  :value="video.factory_only"
                  :checkbox-value="1"
              />
            </div>
            <div class="col-12">
              <Field
                  type="checkbox"
                  name="is_featured"
                  id="cb_is_featured"
                  label="Feature this video above other listings"
                  :value="video.is_featured"
                  :checkbox-value="1"
              />
            </div>
            <div class="col-12 mb-3">
              <Field
                type="checkbox"
                name="enable_sharing"
                id="enable_sharing"
                label="Allow this video to be shared by users"
                :value="video.enable_sharing"
                :checkbox-value="1"
              />
            </div>
            <div class="col-12 mb-3 col-lg-4 pr-lg-4">
              <AssetField
                name="image_id"
                label="Preview Image"
                help-text="1280x720 JPG file recommended"
                :value="video.image_id"
                :types="['image']"
              />
            </div>
            <div class="d-none d-lg-flex col-lg-8"></div>
            <div class="col-12 mb-3">
              <HtmlField name="description" label="Description" :value="video.description" />
            </div>
            <div class="col-12">
              <hr />
            </div>
            <div class="col-12 mb-3 col-lg-6 pr-lg-4">
              <MultiAssignField
                type="select"
                name="brands"
                label="Brands"
                :value="brand_ids"
                :options="brands"
              />
            </div>
            <div class="col-12 mb-3 col-lg-6">
              <MultiAssignField
                type="select"
                name="categories"
                label="Categories"
                :value="category_ids"
                :options="categories"
              />
            </div>
            <div class="col-12">
              <hr />
            </div>
            <div class="col-12 mb-3 col-lg-6 pr-lg-4">
              <MultiAssignField
                type="select"
                name="topics"
                label="Video Topics"
                :value="topic_ids"
                :options="topics"
              />
            </div>
            <div class="col-12 mb-3 col-lg-6">
              <SuggestMultiField
                name="related"
                search-input-name="related_search"
                label="Suggested Videos"
                :search-url="route('admin.videos.search')"
                :value="related_videos"
              />
            </div>
            <div class="col-12">
              <hr />
            </div>
            <div class="col-12 col-lg-8 pr-lg-4">
              <h4 class="text-primary text-uppercase mb-3">Downloads</h4>
              <Downloads :value="video.video_downloads" :visibilities="downloadVisibility" />
            </div>
            <div class="d-none d-lg-flex col-lg-4"></div>
          </div>
        </div>
        <div class="col-12 col-lg-4 col-xl-3 form-button-wrapper">
          <div class="sticky-top">
            <div class="row no-gutters text-center">
              <div class="col-12 pb-2">
                <button type="submit" class="btn btn-success w-50">Save Changes</button>
              </div>
              <div class="col-12 py-2">
                <a :href="route('admin.videos.index')" class="btn btn-danger w-50">Cancel & Exit</a>
              </div>
              <div v-if="video.id && isPublished" class="col-12 py-2">
                <a
                  :href="route('videos.show', { video: video.id })"
                  class="btn btn-info w-50"
                >View in Catalog</a>
              </div>
              <div v-if="video.id" class="col-12 font-size-sm text-center pt-4">
                <span>Last updated on {{ video.updated_at | moment("MM/DD/YYYY") }}</span>
                <span>at {{ video.updated_at | moment("h:mma") }}</span>
                <span v-if="video.updatedBy">{{ " " + video.updatedBy.name }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </FormWrapper>
  </div>
</template>

<script>
import DisplaysAlerts from "mixins/DisplaysAlerts";

export default {
  mixins: [DisplaysAlerts],
  props: {
    video: { type: Object, required: true },
    brands: { type: Array, default: () => [] },
    categories: { type: Array, default: () => [] },
    topics: { type: Array, default: () => [] },
    downloadVisibility: { type: Array, default: () => [] },
  },
  data() {
    return {
      publishOn: null,
      expiresOn: null,
      topic_ids: null,
      category_ids: null,
      brand_ids: null,
      related_videos: null,
    };
  },
  computed: {
    formAction() {
      return !this.video.id
        ? this.route("admin.videos.store")
        : this.route("admin.videos.update", {
            video: this.video.id,
          });
    },
    formMethod() {
      return !this.video.id ? "POST" : "PUT";
    },
    isPublished() {
      return this.video.status == this.$root.constants.PUBLISHED_VIDEO;
    },
    status() {
      var publishOn = this.$moment(this.publishOn);
      var expiresOn = this.$moment(this.expiresOn);
      var today = this.$moment();
      if (expiresOn.isValid() && expiresOn <= today) {
        return "Expired";
      } else if (publishOn.isValid() && publishOn <= today) {
        return "Published";
      } else {
        return "Draft";
      }
    },
  },
  mounted() {
    this.publishOn = this.video.publish_on;
    this.expiresOn = this.video.expires_on;

    this.topic_ids = this.video.topic_ids;
    this.category_ids = this.video.category_ids;
    this.brand_ids = this.video.brand_ids;
    this.related_videos = this.video.related_videos;
  },
};
</script>
